import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import FlexibleCard from '../../Components/FlexibleCard';
import RealStoriesCard from '../../Components/RealStoriesCard';
import CallToActionCard from '../../Components/CallToActionCard';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from './RealStories.module.css';

export default function RealStoriesAbortion({ appLanguage }) {
  const [pageState, setPageState] = useState({
    // General Content
    headerTitle: '',
    extraText: '',
    extraText2: '',
    narrowCardTitle1: '',

    // Individual Large Cards
    largeCard1: {},
    largeCard2: {},
    largeCard3: {},
    largeCard4: {},
    largeCard5: {},
    largeCard6: {},
    // Small Cards Section
    smallCardTitle1: '',
    smallCardDescription1: '',
    smallCardTitle2: '',
    smallCardDescription2: '',
    smallCardTitle3: '',
    smallCardDescription3: '',
    smallCardTitle4: '',
    smallCardDescription4: '',


    // Assets
    headerImage: '',
    arrowIconDark: '',
    heartIcon: '',
    image1: '',
    image2: '',
    image3: '',
    image4: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Real Stories Library';

    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    const getEntryById = (id) => entries.find((e) => e.sys.id === id);
    const getField = (entry, field, locale) =>
      entry?.fields?.[field]?.[locale] || entry?.fields?.[field]?.['en'] || '';

    const getAssetUrlById = (id, locale) => {
      const asset = assets.find((a) => a.sys.id === id);
      const file = asset?.fields?.file?.[locale] || Object.values(asset?.fields?.file || {})[0];
      if (!file?.url) return '';
      return file.url.startsWith('//') ? `https:${file.url}` : file.url;
    };

    const abortionEntry = getEntryById('66C0JjaWUr3wXbYRX3JT74');
    const largeCardEntry = getEntryById('6Z4X1Cusw7TJFzn5A0O9q8');

    setPageState({
      headerTitle: getField(abortionEntry, 'headerTitle', appLanguage),
      extraText: getField(abortionEntry, 'extraText', appLanguage),
      extraText2: getField(abortionEntry, 'extraText2', appLanguage),
      narrowCardTitle1: getField(abortionEntry, 'narrowCardTitle1', appLanguage),
      narrowCardTitle2: getField(abortionEntry, 'narrowCardTitle2', appLanguage),
      smallCardTitle1: getField(abortionEntry, 'smallCardTitle1', appLanguage),
      smallCardDescription1: getField(abortionEntry, 'smallCardDescription1', appLanguage),
      smallCardTitle2: getField(abortionEntry, 'smallCardTitle2', appLanguage),
      smallCardDescription2: getField(abortionEntry, 'smallCardDescription2', appLanguage),
      smallCardTitle3: getField(abortionEntry, 'smallCardTitle3', appLanguage),
      smallCardDescription3: getField(abortionEntry, 'smallCardDescription3', appLanguage),
      smallCardTitle4: getField(abortionEntry, 'smallCardTitle4', appLanguage),
      smallCardDescription4: getField(abortionEntry, 'smallCardDescription4', appLanguage),

      largeCard1: {
        description: getField(largeCardEntry, 'largeCardDescription1', appLanguage),
      },
      largeCard2: {
        description: getField(largeCardEntry, 'largeCardDescription2', appLanguage),
      },
      largeCard3: {
        description: getField(largeCardEntry, 'largeCardDescription3', appLanguage),
      },
      largeCard4: {
        description: getField(largeCardEntry, 'largeCardDescription4', appLanguage),
      },
      largeCard5: {
        description: getField(largeCardEntry, 'largeCardDescription5', appLanguage),
      },
      largeCard6: {
        description: getField(largeCardEntry, 'largeCardDescription6', appLanguage),
      },

      headerImage: getAssetUrlById('3cYMHlvMm6yrWNmY9gVnS0', appLanguage),
      arrowIconDark: getAssetUrlById('35s9SZBtTGy9KGs0lc41lt', appLanguage),
      arrowIconWhite: getAssetUrlById('5t0SZSeDrtBlIZ3o0Apjcu', appLanguage),
      heartIcon: getAssetUrlById('740H3V1s40GxiaZiqj79MY', appLanguage),
      image1: getAssetUrlById('vOXgrGXEMSZUSsfvgBHl9', appLanguage),
      image2: getAssetUrlById('5J3wSsAw8I1n2G15MO9dwz', appLanguage),
      image3: getAssetUrlById('4fmbucUjI0K41fe3F9Glvy', appLanguage),
      image4: getAssetUrlById('347Kd8twz9RPwSicZyEJwF', appLanguage),
      image5: '',
    });
  }, [appLanguage]);

  return (
    <div className={styles.homePageContainer}>
      <TopNavBarNew backgroundColor="#4350E6" breadcrumbColor="#fff" />
      <div className={styles.libraryAbortionMenuContainer}>
        {/* Header Section */}
        <div className={styles.headerContainer}>
          <HeaderCardNew
            title={pageState.headerTitle}
            image={pageState.headerImage}
            backgroundColor="#4350E6"
            titleColor="#fff"
            borderRadius="0px"
            imageSize="130%"
            imageBottom = '-3px'
            imageRight = '60px'
            imageTransform = 'translate(0, 0)'
          />
        </div>
        <div className={styles.bottomSpaceHeader}></div>

        <div className={styles.leftAlignWrapper}>

          {/* Extra Text Section */}
          <div className={styles.extraTitleTwo}>{pageState.extraText}</div>

      </div>


      <div className={styles.realStoriesContainer}>
  <RealStoriesCard
    title={pageState.smallCardTitle1}
    isLink={true}
    buttonLink="/real-story-one"
    description={pageState.smallCardDescription1}
    image={pageState.image1}
    icon={pageState.arrowIconDark}
    backgroundColor="#FDE8D8"
  />
  <RealStoriesCard
    title={pageState.smallCardTitle2}
    isLink={true}
    buttonLink="/real-story-two"
    description={pageState.smallCardDescription1}
    image={pageState.image2}
    icon={pageState.arrowIconDark}
    backgroundColor="#FFE6EE"
  />
  <RealStoriesCard
    title={pageState.smallCardTitle3}
    isLink={true}
    buttonLink="/real-story-three"
    description={pageState.smallCardDescription1}
    image={pageState.image3}
    icon={pageState.arrowIconDark}
    backgroundColor="#B4BCFF"
  />
  <RealStoriesCard
    title={pageState.smallCardTitle4}
    isLink={true}
    buttonLink="/real-story-four"
    description={pageState.smallCardDescription1}
    image={pageState.image4}
    icon={pageState.arrowIconDark}
    backgroundColor="#DAF0FF"
  />
</div>

    <div className={styles.leftAlignWrapper}>

          {/* Extra Text Section */}
          <div className={styles.extraTitleTwo}>{pageState.extraText2}</div>

          </div>
          <div className={styles.bottomSpaceHeader}></div>
        {/* Render Individual Large Cards */}
        <FlexibleCard
          description={pageState.largeCard1.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          description={pageState.largeCard2.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          description={pageState.largeCard3.description}
          width="351px"
          borderRadius="10px"
        />  

        <FlexibleCard
          description={pageState.largeCard4.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          description={pageState.largeCard5.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          description={pageState.largeCard6.description}
          width="351px"
          borderRadius="10px"
        />

        {/* Call To Action Card 1 */}
        <CallToActionCard
          title={pageState.narrowCardTitle1}
          icon={pageState.arrowIconWhite}
          showIcon={true}
          isLink={false}
          disableCursor={true}
          useCardGradient={true}
          titleColor="#fff"
          cardGradient="linear-gradient(90deg, #E12541 0%, #F85833 100%)"
          width="356px"
          height="52px"
          iconPosition="right" 
          borderRadius="10px"
          titleFont="Inter"
          titleFontSize="13px"
          titleFontWeight="400"
          mailto="aya.app@vitalaglobal.org" // 📩 Opens email app when clicked
        />
<div className={styles.topSpace}></div>
      </div>
      <div className={styles.bottomSpace}></div>
      <div className={styles.bottomSpace}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
  );
}
